// extracted by mini-css-extract-plugin
module.exports = {"primary":"_2PYHdAwZelkd","secondary":"FKZH_a7-Hham"};